<template>
  <div class="task-list" ref="taskList">
    <div v-for="(task, i) in tasks" :key="`task${i}`" class="task-row">
      <div :class="[showBorder(i)]">
        <div
          class="draggable-task"
          draggable="true"
          @dragstart="indexPick = i"
          @dragenter="indexDrop = i"
          @dragover="indexOver = i"
          @dragleave="indexOver = undefined"
          @drop="indexOver = undefined"
          @dragend="moveTask(indexPick, indexDrop)"
        >
          <i class="material-icons mr-2 ml-2 drag-indicator">
            drag_indicator
          </i>
          <TaskInput
            :index="i"
            :ref="`task${i}`"
            :showDelete="showDelete"
            v-model="tasks[i]"
            @blurTask="setFocus(i, 'blur')"
            @addTask="addTask(i + 1)"
            @clickRemoveTask="removeTask(i)"
            @removeTask="removeTask(i, i - 1)"
            @moveTask="moveTask(i, $event)"
            @changeFocus="setFocus($event, 'focus')"
          />
        </div>
      </div>
    </div>
    <div class="center-flex mt-2">
      <b-button
        class="btn-medium pl-4 pr-4"
        variant="primary"
        @click="addTask()"
      >
        {{ resources.addTask }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TaskInput from '@/components/ActionPlan/TaskInput.vue'

export default {
  components: {
    TaskInput,
  },

  props: {
    tasks: {
      type: Array,
      default: () => ({ text: '', done: false }),
    },
    invalidTasks: {
      type: Array,
      default: () => [],
    },
    focusOnTask: {
      type: Number,
      default: undefined,
    },
  },

  data() {
    return {
      indexPick: undefined,
      indexDrop: undefined,
      indexOver: undefined,
    }
  },

  watch: {
    focusOnTask(index) {
      if (index === undefined) return
      this.setFocus(index, 'focus')
    },
  },

  computed: {
    ...mapGetters({
      resources: 'taskList',
    }),
    showDelete() {
      return this.tasks.length > 1
    },
  },
  methods: {
    addTask(to) {
      this.tasks.push({ text: '', done: false })
      to && this.setFocus(to, 'focus')
    },
    removeTask(i, to) {
      if (this.tasks.length === 1) return

      this.tasks.splice(i, 1)
      to && this.setFocus(to, 'focus')
    },
    showBorder(i) {
      if (this.indexOver !== i || i === this.indexPick) return ''
      return i < this.indexPick ? 'show-top-border' : 'show-bot-border'
    },
    setFocus(i, action) {
      i = i < 0 || i >= this.tasks.length ? 0 : i
      /* istanbul ignore next */
      this.$nextTick(function() {
        this.$refs[`task${i}`][0].$refs[`taskInput${i}`][action]()
      })
    },
    moveTask(from, to) {
      if (to < 0 || to >= this.tasks.length) return

      this.tasks.splice(to, 0, this.tasks.splice(from, 1)[0])
      this.setFocus(to, 'focus')
    },
  },
  created() {
    if (!this.tasks.length) {
      this.addTask()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/mixins/breakpoints';

[draggable] {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -khtml-user-drag: element;
  -webkit-user-drag: element;
}

.drag-indicator {
  @include media-breakpoint-down(sm) {
    display: none;
  }
}

.task-list {
  max-width: 700px;

  .center-flex {
    display: flex;
    justify-content: center;
  }

  .show-top-border {
    border-top: 1px solid map-get($theme-colors, 'primary');
  }

  .show-bot-border {
    border-bottom: 1px solid map-get($theme-colors, 'primary');
  }

  .draggable-task {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px;
    border-radius: 24px;
    cursor: pointer;

    &:hover {
      background-color: map-get($theme-colors, 'light');

      .material-icons {
        opacity: 1;
      }
    }

    .material-icons {
      line-height: 26px;
      font-size: 26px;
      opacity: 0;
      cursor: pointer;
    }
  }
}
</style>
